const _excluded = ["canAutocomplete", "open"],
  _excluded2 = ["children", "prefix", "suffix"],
  _excluded3 = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { components } from 'react-select';
import { autocompleteDefaultMaxFetchItems, autocompleteDefaultDebounceMs, autocompleteDefaultCacheOptions } from "./input-locator.constants";
import clsx from 'clsx';
import { InputAsyncSelect } from "../select";
import { apiAutocomplete } from '@isyc-react/oc-api/requests/autocomplete';
import { useTranslation } from 'react-i18next';
import { nsform } from "../../../i18n/namespaces";
import '@isyc-react/design/main';
import "./input-locator.style.scss";
const InputLocatorValueContainer = props => {
  const {
      canAutocomplete,
      open
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('input-locator-value-container', {
      'cursor-pointer': !canAutocomplete
    }),
    onClick: () => open && open()
  }, /*#__PURE__*/React.createElement(components.ValueContainer, rest));
};
const LocatorInputControl = props => {
  const {
      children,
      prefix: Prefix,
      suffix: Suffix
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(components.Control, rest, Prefix && /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, /*#__PURE__*/React.createElement(Prefix, null)), children, Suffix && /*#__PURE__*/React.createElement("div", {
    className: 'd-flex align-items-center mx-2'
  }, /*#__PURE__*/React.createElement(Suffix, null)));
};
const LocatorInputMenu = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  const inputValue = props.selectProps.inputValue;
  if (!inputValue) return null;
  return /*#__PURE__*/React.createElement(components.Menu, rest, children);
};
export const LocatorInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _autocomplete$cacheOp, _autocomplete$promise, _autocomplete$debounc;
  const {
    value,
    error,
    onChange,
    onSearchChange,
    size,
    readOnly,
    disabled,
    onFocus
  } = props;
  const {
    businessUnitId,
    objectTypeId,
    autocomplete,
    prefix,
    suffix,
    setModal
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  const canAutocomplete = Boolean(!readOnly && autocomplete && objectTypeId);
  const promiseOptions = (inputValue, resolve) => {
    if (autocomplete && objectTypeId) {
      var _autocomplete$maxFetc;
      apiAutocomplete({
        businessUnitId: businessUnitId ? businessUnitId.toString() : null,
        search: inputValue.toLowerCase(),
        maxItems: typeof autocomplete !== 'boolean' ? (_autocomplete$maxFetc = autocomplete.maxFetchItems) !== null && _autocomplete$maxFetc !== void 0 ? _autocomplete$maxFetc : autocompleteDefaultMaxFetchItems : autocompleteDefaultMaxFetchItems,
        objectTypeId: objectTypeId
      }).then(response => {
        var _response$data$map, _response$data;
        const options = (_response$data$map = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.map(item => ({
          value: item.id.toString(),
          label: item.name
        }))) !== null && _response$data$map !== void 0 ? _response$data$map : [];
        resolve(options);
      }).catch(error => {
        console.error('[Locator autocomplete] Search aborted: error in object locator autocomplete search');
        console.error('[Locator autocomplete] Searched: ', inputValue.toLowerCase());
        console.error('[Locator autocomplete] Object type id: ', objectTypeId);
        console.error('[Locator autocomplete] Error response: ', error.response);
        resolve([]);
      });
    } else resolve([]);
  };
  return /*#__PURE__*/React.createElement(InputAsyncSelect, {
    ref: ref,
    cacheOptions: typeof autocomplete !== 'boolean' ? (_autocomplete$cacheOp = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.cacheOptions) !== null && _autocomplete$cacheOp !== void 0 ? _autocomplete$cacheOp : autocompleteDefaultCacheOptions : autocompleteDefaultCacheOptions,
    promise: typeof autocomplete !== 'boolean' ? (_autocomplete$promise = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.promise) !== null && _autocomplete$promise !== void 0 ? _autocomplete$promise : promiseOptions : promiseOptions,
    debounce: typeof autocomplete !== 'boolean' ? (_autocomplete$debounc = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.debounce) !== null && _autocomplete$debounc !== void 0 ? _autocomplete$debounc : autocompleteDefaultDebounceMs : autocompleteDefaultDebounceMs,
    placeholder: autocomplete ? t('input.locator.placeholder.autocomplete') : t('input.locator.placeholder.default'),
    error: error,
    isSearchable: canAutocomplete,
    value: value,
    isClearable: !readOnly,
    size: size,
    disabled: disabled,
    components: {
      Menu: LocatorInputMenu,
      DropdownIndicator: () => /*#__PURE__*/React.createElement(React.Fragment, null),
      ValueContainer: props => /*#__PURE__*/React.createElement(InputLocatorValueContainer, _extends({}, props, {
        canAutocomplete: canAutocomplete,
        open: () => {
          if (!canAutocomplete) {
            setModal && setModal(true);
            onFocus && onFocus();
          }
        }
      })),
      Control: props => /*#__PURE__*/React.createElement(LocatorInputControl, _extends({}, props, {
        prefix: prefix,
        suffix: suffix
      }))
    },
    onChange: option => {
      onChange && onChange(option);
    },
    onInputChange: (value, meta) => {
      onSearchChange && onSearchChange(value, meta);
    }
  });
});